import React from "react";
import { Switch, Link, Route, Redirect } from "react-router-dom";

import Navigation from "./utils/Navigation";
import CampaignNew from "./posts/CampaignNew";
import CampaignManager from "./posts/CampaignManager";
import CampaignsList from "./posts/CampaignsList";
import Destinations from "./destinations/Destinations";
import Timeline from "./posts/Timeline";
import Reports from "./posts/Reports";

export default function Dashboard() {
  return (
    <>
      <Navigation />
      <Switch>
        <Route path="/campaigns/add">
          <CampaignNew />
        </Route>
        <Route path="/campaigns/edit/:id/:step">
          <CampaignManager />
        </Route>
        <Route path="/timeline">
          <Timeline />
        </Route>
        <Route path="/login">
          <Redirect to="/" />
        </Route>
        <Route path="/register">
          <Redirect to="/" />
        </Route>
        <Route path="/destinations">
          <div className="layout mt3">
            <Destinations />
          </div>
        </Route>
        <Route path="/reports">
          <div className="layout mt3">
            <Reports />
          </div>
        </Route>
        <Route path="/">
          <CampaignsList />
        </Route>
      </Switch>
    </>
  );
}
